// Marca blanca para clientes de reseller.
//
// Esconde toda mención a Inovanex / Incenit dentro del panel: el "by Inovanex"
// del logo, el menú de links del header, el banner de Incenit del sidebar, los
// botones de WhatsApp de soporte y el badge + links sociales del login.
//
// Se activa por DOS vías independientes (basta con una):
//
//   1. DOMINIO NEUTRO. Si se entra por un host de WHITE_LABEL_HOSTS
//      (apps.cdnrad.com), la marca se esconde desde el primer pixel, incluida
//      la pantalla de login — que es pública y se pinta antes de saber quién
//      entra. Es la vía que garantiza que un cliente de reseller no vea la
//      marca NUNCA, ni siquiera la primera vez.
//
//   2. FLAG POR RADIO. `white_label: true` en la colección `radios`. Cubre a
//      los clientes de reseller que entren por el dominio principal (un
//      bookmark viejo, por ejemplo). Lo puebla app.inovanex vía push cuando
//      liga/desliga apps de cuentas reseller, y también se puede tildar a
//      mano desde el ABM de radios.
//
// El estado es un observable de Vue para que al cambiar de radio el header y
// el sidebar se actualicen solos, sin recargar. Además se espeja en
// localStorage para que el login y el FAB de WhatsApp —que se montan antes de
// que se carguen las radios— no parpadeen mostrando la marca.
//
// El caché NO se limpia en el logout a propósito: si se limpiara, el login
// volvería a mostrar la marca cada vez, que es lo que queremos evitar.

import Vue from "vue";

const CACHE_KEY = "lx_white_label";

// Hosts que sirven el panel en modo marca blanca de forma incondicional.
// Agregar acá cualquier dominio neutro nuevo que se ponga al aire.
const WHITE_LABEL_HOSTS = ["apps.cdnrad.com"];

function hostIsNeutral(): boolean {
  try {
    const h = String(window.location.hostname || "").toLowerCase();
    return WHITE_LABEL_HOSTS.indexOf(h) >= 0;
  } catch (_) {
    return false;
  }
}

function readCache(): boolean {
  try {
    return localStorage.getItem(CACHE_KEY) === "1";
  } catch (_) {
    return false;
  }
}

// El dominio manda y no se puede desactivar: si estamos en un host neutro,
// arrancamos en true y ningún setWhiteLabel(false) lo baja.
const forcedByHost = hostIsNeutral();

const state = Vue.observable({ active: forcedByHost || readCache() });

/**
 * Guarda el flag de la radio activa. La llama Navigation al resolver la radio
 * y el login al recibir la respuesta del backend.
 */
export function setWhiteLabel(value: any): void {
  const next = forcedByHost || !!value;
  state.active = next;
  try {
    localStorage.setItem(CACHE_KEY, next ? "1" : "0");
  } catch (_) {
    /* modo privado / storage bloqueado: seguimos sólo con el estado en memoria */
  }
}

/**
 * true si hay que esconder las marcas propias.
 * Usar SIEMPRE desde un `computed` para que sea reactivo; desde `data()`
 * quedaría congelado en el valor del primer render.
 */
export function isWhiteLabel(): boolean {
  return state.active;
}

/** true si la marca blanca viene impuesta por el dominio (no por la radio). */
export function isWhiteLabelHost(): boolean {
  return forcedByHost;
}

export default { setWhiteLabel, isWhiteLabel, isWhiteLabelHost };
